import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FabricService} from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-permission-resources';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(private fabricService: FabricService) {

  }

  getRoles(): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_authz_roles');
  }

  getRoleByName(name): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_authz_roles_name', {name});
  }

  getGroups(payload?): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_authz_usergroups', payload);
  }

  getGroupByName(name): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_authz_usergroups_name', {name});
  }

  postGroups(formData): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_mgmt_authz_usergroups', formData);
  }

  deleteGroup(name): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'delete_mgmt_authz_usergroups_name', {name});
  }

  getRoleAssignments(payload?): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_authz_role-assignments', payload);
  }

  postRoleAssignment(role): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_mgmt_authz_role-assignments', role);
  }

  deleteRoleAssignmentById(id): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'delete_mgmt_authz_role-assignments_id', {id});
  }

  getAuthAssignedPermissions(scope: string): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_authz_assigned-permissions', {scope});
  }

}
